import React, { useState } from "react";
import { Grid, TextField } from "@material-ui/core";
import { useFormContext } from "react-hook-form";
import { AutocompleteForm, FormDropZone } from "components";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import TextFieldAutoCompleteFree from "components/TextFieldAutoCompleteFree";

const campoRequerido = {
  required: { value: true, message: "Campo requerido" },
};
const FormNuevaSolicitud = ({ catalogos, usuario }) => {
  const classesTablero = useStylesTablero();
  const { register, errors, control, watch } = useFormContext();
  const [modulos, setModulos] = useState([]);
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <AutocompleteForm
          control={control}
          name="tipo_solicitud"
          label="TIPO DE SOLICITUD"
          defaultValue={null}
          rules={campoRequerido}
          error={errors.tipo_solicitud?.message}
          options={[
            { idopc: 1, opcion: "MEJORA" },
            { idopc: 2, opcion: "INCIDENCIA" },
            { idopc: 3, opcion: "NUEVO MÓDULO" },
            { idopc: 4, opcion: "AJUSTE" },
          ]}
          optionSelected={{ id: "idopc", label: "opcion" }}
        />
      </Grid>
      <Grid item xs={6}>
        <AutocompleteForm
          control={control}
          name="idprioridad"
          label="PRIORIDAD"
          defaultValue={null}
          rules={campoRequerido}
          error={errors.idprioridad?.message}
          options={[
            { idopc: 1, opcion: "ALTA" },
            { idopc: 2, opcion: "MEDIA" },
            { idopc: 3, opcion: "BAJA" },
          ]}
          optionSelected={{ id: "idopc", label: "opcion" }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextFieldAutoCompleteFree
          control={control}
          label="ÁREA"
          fullWidth
          required={true}
          error={errors.area?.message}
          rules={campoRequerido}
          name="area"
          options={catalogos.areas}
          optionSelected={{
            label: "area",
            id: "idarea",
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <AutocompleteForm
          control={control}
          name="tipo_app"
          label="TIPO DE APLICACIÓN"
          defaultValue={null}
          rules={campoRequerido}
          error={errors.tipo_app?.message}
          options={[
            { idopc: 2, opcion: "Web" },
            { idopc: 1, opcion: "Móvil" },
            { idopc: 3, opcion: "Escritorio" },
          ]}
          optionSelected={{ id: "idopc", label: "opcion" }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="SOLICITANTE"
          name="solicitante"
          inputRef={register(campoRequerido)}
          error={errors.solicitante}
          helperText={errors.solicitante?.message}
          defaultValue={`${usuario.nombre} ${usuario.apaterno} ${usuario.amaterno}`}
          className={classesTablero.field}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={6}>
        <AutocompleteForm
          control={control}
          name="proyecto"
          label="SISTEMA"
          rules={campoRequerido}
          error={errors.proyecto?.message}
          options={catalogos.proyectos}
          optionSelected={{
            label: "nproyecto",
            id: "idproyecto",
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <AutocompleteForm
          control={control}
          name="modulo"
          label="MÓDULO"
          rules={campoRequerido}
          error={errors.modulo?.message}
          options={
            watch("proyecto")?.idproyecto
              ? catalogos.modulos.filter(
                  (m) => m.idproyecto == watch("proyecto").idproyecto
                )
              : []
          } 
          optionSelected={{
            label: "nmodulo",
            id: "idmodulo",
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldAutoCompleteFree
          control={control}
          label="CORREO DE CONTACTO"
          fullWidth
          required={true}
          error={errors.correo?.message}
          rules={campoRequerido}
          name="correo"
          options={[]}
          optionSelected={{
            label: "info",
            id: "info",
          }}
          defaultValue={[]}
        />
        {/* <TextField
                    fullWidth
                    label="CORREO DE CONTACTO"
                    name="correo"
                    inputRef={register({...campoRequerido,pattern:{value:/^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i, message:'Formato de correo incorrecto'}})} //  /^\S+@\S+$/i
                    error={errors.correo}
                    helperText={errors.correo?.message}
                    type='email'
                /> */}
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="TÍTULO"
          name="titulo"
          inputRef={register(campoRequerido)}
          error={errors.titulo}
          helperText={errors.titulo?.message}
          className={classesTablero.field}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="NÚMERO DE TICKET"
          name="problematica"
          error={errors.problematica}
          helperText={errors.problematica?.message}
          className={classesTablero.field}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          minRows={3}
          multiline
          label="DESCRIPCIÓN DE LA SOLICITUD"
          name="desc_solicitud"
          inputRef={register(campoRequerido)}
          error={errors.desc_solicitud}
          helperText={errors.desc_solicitud?.message}
          className={classesTablero.field}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12}>
        <FormDropZone
          rules={{}}
          name="filefield"
          control={control}
          label="control"
        />
      </Grid>
    </Grid>
  );
};

export default FormNuevaSolicitud;
